import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#56A689",
    "col1l": "#B1ECD7",
    "col1n": "#8AD7BB",
    "col2d": "#00AFAF",
    "col2n": "#00DEDE"
}
function PlaInd035({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill="#FFF"
                    d="M385 385V0h-69.75v41.65q-.043 2.317-.1 4.6l-.05 5.5q-.054 5.758-.05 11.5.023.375 0 .75.02.75 0 1.5.06 7.013.2 14v77.3q-56.02-5.542-112.95-7.05-58.172-1.533-117.3 1.2-42.262 1.932-85 6.05v228h385z"
                    id="PlaInd035__Layer11_0_FILL"
                />
                <path
                    fill={colors.col1n}
                    fillOpacity={0.502}
                    d="M385 228V86.1L317 .05l-.05-.05H0v228h385z"
                    id="PlaInd035__Symbol_87_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    fillOpacity={0.8}
                    d="M385 228V86.1L317 .05l-.05-.05H0v228h385z"
                    id="PlaInd035__Symbol_77_0_Layer0_0_FILL"
                />
                <path
                    fill="#A1DDFF"
                    d="M313.95 118V0H0v118h313.95z"
                    id="PlaInd035__Layer7_0_FILL"
                />
                <path
                    fill="#96BCD2"
                    d="M313.95 70h-45V41h-104v53H51.45V60.5H0V118h313.95V70z"
                    id="PlaInd035__Layer7_0_MEMBER_0_FILL"
                />
                <path
                    fill="#FFF"
                    fillOpacity={0.4}
                    d="M20.1 117.85h55.45L110.15 0h-53.6L20.1 117.85M47 0H36.5L.65 117.85h9.45L47 0m82.4 0h-10.45L86.1 117.85h9.4L129.4 0m181.1 117.85l3.5-15.65V57.65l-12.95 60.2h9.45M192.95 1.1H182.5l-30.55 118.1h9.45L192.95 1.1M255.7 0h-10.35L217 117.85h9.45L255.7 0m54.55 40.1L306.45 0H265.9l-28.95 117.85h55.45l17.85-77.75z"
                    id="PlaInd035__Layer7_0_MEMBER_1_FILL"
                />
                <path
                    fill="#728291"
                    d="M316.95 0h-5.55v117.2H195.2V0h-5.95v117.2H73.6V0h-5.55v117.2H-.2v5.3h317.15V0z"
                    id="PlaInd035__Layer7_1_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M355.95 78.6v-3L305.05 0H0v78.6h355.95z"
                    id="PlaInd035__Symbol_78_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2d}
                    d="M355.95 3V0H0v3h355.95z"
                    id="PlaInd035__Symbol_79_0_Layer0_0_FILL"
                />
                <path
                    fill="#999"
                    d="M245.9 199.7v15.85q2.35 1.2 3.9 0V199.7q-1-3.75-3.9 0m-14.25-4.6q2 3.65 3.95 0v-5.85q-1.95-6.65-3.95-5.85v11.7m125.05-14.25l-3.75-4.85-.05 43.95-4.4-5.5V199.7q-1.3-2.8-4.05 0v9.75l-7.75-9.75q-4.85-3.55-4.75 0l12.75 16.4-.4-.55 7.15 9.2h.1l3.45 4.35q3.2 2.15 5.6 0l-3.9-4.7v-43.55z"
                    id="PlaInd035__Layer2_0_FILL"
                />
                <path
                    fill="#434343"
                    d="M350.95 195.75q-.3-.25-.6-.35-.4-.2-.95-.2-53.5-2.55-100.1 0-.7-3.9-19.55-18.05-.1.2-.05.55v2.8l13 19.2h108.85v-2.25q-.05-.9-.4-1.45-.1-.15-.2-.25z"
                    id="PlaInd035__Layer2_0_MEMBER_0_FILL"
                />
                <path
                    fill="#CCC"
                    d="M328.1 140.9q-.35-.35-.8-.35-.45 0-.8.35-.25.3-.25.75t.25.75l.2.2q.05 0 .1.15v.05l.95 1.1v-.5q1.75 2.45 2.9 4v.1L362.3 188v-4.4l-34.2-42.75v.05z"
                    id="PlaInd035__Layer2_0_MEMBER_2_FILL"
                />
                <path
                    d="M243.8 215.55v4.5h8.1v-4.5h-8.1m-6.15-20.45h-8.1v4.5h8.1v-4.5m116.3 34v4.5h8.35v-4.5h-8.35z"
                    id="PlaInd035__Layer2_0_MEMBER_3_FILL"
                />
                <path
                    fill="#999"
                    d="M327.75 143.4v3.8l.8.9v27.65q2.35 6.5 3.2 0V148.9l-1.1-1.4v-2.35l-1.95-2.4q-.9-.15-.95.65z"
                    id="PlaInd035__Layer2_0_MEMBER_4_FILL"
                />
                <path
                    d="M349.4 195.2q.55 0 .95.2.3.1.6.35L337 177.35q-1.2-1.75-3.45-1.6H232.1q-2.05.25-2.35 1.4l13.6 19q.65-.8 2-.95H349.4z"
                    id="PlaInd035__Layer2_0_MEMBER_5_FILL"
                />
                <path
                    fill="#666"
                    d="M259.9 145.4q0 .85.3 1.55l2.4 3.9-.1.1q-2.6 2.6-2.6 6.3 0 2.75 1.45 4.9h-.05q.1.15.3.3.1.15.25.15.95.6 2.25.95 5.05 1.1 10.05 0 .9-.35 1.7-.95.05 0 .15-.15l.2-.2v.05q1.5-2.25 1.5-5.05 0-3.7-2.6-6.3-.1-.1-.15-.2l2.35-3.8q.3-.7.3-1.55 0-1.5-1-2.5-.45-.4-1-.65-6.7-2.55-13.7 0-.55.25-1 .65-1 1-1 2.5m9.1-2.1q1.65.05 3.2.3h.1q3.3.7 2.35 3.3l-1.4 2.6q-2-1.15-4.45-1.15-2.5 0-4.5 1.2l-1.45-2.65q-1.05-2.7 2.5-3.3 1.55-.25 3.1-.3h.55z"
                    id="PlaInd035__Layer2_1_MEMBER_0_FILL"
                />
                <path
                    fill="#666"
                    d="M294.6 145.7q-.35-.3-.75-.5-5.55-2.05-11.25 0-.5.2-.8.5-.85.85-.85 2.05 0 .75.25 1.3l2 3.2q-.1.05-.15.05-2.1 2.15-2.1 5.2 0 2.25 1.15 4h-.05q.15.15.3.25.05.1.2.15.75.45 1.8.75 4.15.9 8.25 0 .75-.3 1.4-.75l.15-.15.15-.15q1.25-1.8 1.25-4.1 0-3.05-2.15-5.2-.1-.05-.15-.15l1.95-3.1q.2-.55.2-1.3 0-1.2-.8-2.05m-6.2.35q1.3.05 2.65.25 2.8.55 1.95 2.7l-1.15 2.1q-1.65-.9-3.6-.9-2.1 0-3.7.95l-1.2-2.15q-.85-2.2 2.05-2.7 1.25-.2 2.55-.25H288.4z"
                    id="PlaInd035__Layer2_1_MEMBER_1_FILL"
                />
                <path
                    fill="#666"
                    d="M310.15 146.8q-.3-.25-.65-.45-4.7-1.7-9.5 0-.45.2-.7.45-.7.7-.7 1.75 0 .6.2 1.1l1.7 2.7q-.1.05-.15.05-1.75 1.8-1.75 4.4 0 1.9.95 3.35h-.05q.15.15.3.2 0 .1.15.15.65.4 1.5.65 3.55.75 7 0 .65-.25 1.2-.65 0-.05.1-.15.1-.05.15-.1 1.05-1.55 1.05-3.45 0-2.6-1.85-4.4-.05-.05-.1-.15l1.65-2.6q.15-.5.15-1.1 0-1.05-.65-1.75m-7.8.5q1.05-.15 2.15-.2h.4q1.1.05 2.25.2 2.35.45 1.65 2.3l-1 1.75q-1.4-.75-3.05-.75-1.75 0-3.1.8l-1.05-1.8q-.7-1.85 1.75-2.3z"
                    id="PlaInd035__Layer2_1_MEMBER_2_FILL"
                />
                <path
                    fill="#999"
                    d="M109.05 148.35H90l25.65 11.95-6.6-11.95M54.2 140.1q-1.35-1.35-2.7-2.45-5.2-4-11.65-5.1l4.5-1.45-13.65-5H19.55l-9.8 18 3.2-.5q-4.85 6.75-4.85 15.6 0 11.15 7.9 19.1 1.65 1.65 3.5 2.95l-9.25 9h6l3.95-3.85q1.05-1 2-2l1-.9q.05 0 .1.05 5.3 2.65 11.8 2.65 11.2 0 19.1-7.9 7.95-7.95 7.95-19.1 0-11.2-7.95-19.1z"
                    id="PlaInd035__Symbol_1_0_Layer0_1_FILL"
                />
                <path
                    fill="#666"
                    d="M35.1 129.65q-12.15 0-20.7 8.6-8.6 8.6-8.6 20.7 0 8.7 4.45 15.55 1.75 2.75 4.15 5.15 1.7 1.65 3.5 3 1.25.9 2.6 1.7.45.3 1.05.65 1.45.75 2.95 1.4 4.7 1.7 10.05 1.8h66.7q7.15-.15 12.3-5.25 5.25-5.35 5.25-12.8 0-7.5-5.25-12.8-4-3.95-8.85-5.6L46 131.65q-5.05-2-10.9-2m-16.95 12.6q7-6.95 16.8-6.95 9.85 0 16.85 6.95 6.95 7 6.95 16.85 0 9.85-6.95 16.8-7 7-16.85 7-3.25 0-6.25-.8-1.6-.4-3.15-1.1-.6-.2-1.2-.55-1.4-.7-2.65-1.6-1.9-1.25-3.55-2.95-6.95-6.95-6.95-16.8 0-9.85 6.95-16.85z"
                    id="PlaInd035__Symbol_1_0_Layer0_2_FILL"
                />
                <path
                    fill="#666"
                    d="M30.6 163.45q1.8 1.8 4.35 1.8 2.6 0 4.4-1.8 1.8-1.75 1.8-4.35 0-2.6-1.8-4.4-1.8-1.85-4.4-1.85-2.55 0-4.35 1.85-1.85 1.8-1.85 4.4 0 2.6 1.85 4.35z"
                    id="PlaInd035__Symbol_1_0_Layer0_3_FILL"
                />
                <path
                    fill="#CCC"
                    d="M36.65 157.4q-.7-.7-1.7-.7-.95 0-1.7.7-.65.7-.65 1.7 0 .95.65 1.65.75.7 1.7.7.35 0 .55-.05 0-.05.05-.05l11.75 11.7 2.85-.5-12.8-13.05v-.4q0-1-.7-1.7z"
                    id="PlaInd035__Symbol_1_0_Layer0_4_FILL"
                />
                <path
                    d="M55.85 173.4q-2.15-2.1-5.15-2.1-3.05 0-5.25 2.1-2 2.15-2.15 5.05h14.65q-.05-2.9-2.1-5.05z"
                    id="PlaInd035__Symbol_1_0_Layer0_4_MEMBER_0_FILL"
                />
                <path
                    fill="#333"
                    d="M29.05 109.25v-6.05H13.6v6.05h15.45z"
                    id="PlaInd035__Symbol_1_0_Layer0_5_FILL"
                />
                <path
                    d="M44.2 96.6H21.5q-7-.35-7.95 6.7H50.3v-1.45q-.2-4.45-6.1-5.25z"
                    id="PlaInd035__Symbol_1_0_Layer0_6_FILL"
                />
                <g
                    id="PlaInd035__Symbol_76_0_Layer0_0_FILL"
                    fill={colors.col1d}
                >
                    <path d="M316.95 157v-37L0 122.5V157h316.95z" />
                    <path
                        fillOpacity={0.749}
                        d="M385 243.1V0h-68.05q-1.034 16.563-1.5 33-.182 6.636-.3 13.25l-.05 5.5q-.054 5.758-.05 11.5.023.375 0 .75.02.75 0 1.5.162 27.427 1.9 54.5v37L385 243.1z"
                    />
                </g>
                <g id="PlaInd035__Layer2_0_MEMBER_1_FILL">
                    <path
                        fill="#666"
                        d="M335.9 129.7q-4.15-4.1-10-4.1-4.45 0-7.8 2.3-.8.5-1.65 1.3l-.6.5q-4.1 4.1-4.1 10 0 1.7.25 3.15.6 2.65 2.2 4.9l1.4 1.85q-1.6-2.25-2.1-4.95-.4-1.45-.4-3.15 0-5.25 3.35-9.1.4-.45.85-.9 1-1.05 2.25-1.8 3.35-2.3 7.75-2.3 5.85 0 9.95 4.1.45.4.85.7l-1.7-2-.5-.5z"
                    />
                    <path d="M339 133.35q-.45-.55-.9-1.15-.4-.3-.85-.7-4.1-4.1-9.95-4.1-4.4 0-7.75 2.3-1.25.75-2.25 1.8-.45.45-.85.9-3.35 3.85-3.35 9.1 0 1.7.4 3.15.5 2.7 2.1 4.95.45.5.85 1.1.15.1.3.25.25.3.55.6 1.7 1.7 3.65 2.75 2.9 1.35 6.35 1.35 5.65 0 9.65-3.75.25-.2.3-.35 4.25-4.15 4.25-10.05 0-4.5-2.45-7.95-.05-.05-.05-.2z" />
                </g>
                <g id="PlaInd035__Layer2_0_MEMBER_6_FILL">
                    <path d="M362.6 169.85q-4.9 0-8.75 2.6-1.4.85-2.55 2.05-.5.5-.95 1.05-3.75 4.3-3.75 10.2 0 1.95.45 3.6.6 3 2.35 5.5.45.6.95 1.25.2.1.35.3.25.3.6.7 1.95 1.9 4.15 3.05 3.25 1.6 7.15 1.6 6.35 0 10.85-4.25l.4-.4q4.7-4.7 4.7-11.35 0-5.05-2.75-8.95-.05-.05-.05-.2-.5-.65-1-1.25-.45-.4-.9-.85-4.65-4.65-11.25-4.65m-2 14.1q.95.4 2.25 1.5l.75-.5q1.1-.75 1.8-1l.2.15q-.7.55-1.7 1.15l-.6.5q1.05 1 2.4 2.5-.1.25-.25.25-.4 0-2.1-1.6-.3-.35-.7-.7-1.55 1.1-3.45 2.65-.2-.15-.2-.35 0-.3 2.55-2.2.35-.25.7-.4-1-1.15-1.65-1.95z" />
                    <path
                        fill="#0FF"
                        d="M362.85 185.45q-1.3-1.1-2.25-1.5.65.8 1.65 1.95-.35.15-.7.4-2.55 1.9-2.55 2.2 0 .2.2.35 1.9-1.55 3.45-2.65.4.35.7.7 1.7 1.6 2.1 1.6.15 0 .25-.25-1.35-1.5-2.4-2.5l.6-.5q1-.6 1.7-1.15l-.2-.15q-.7.25-1.8 1l-.75.5z"
                    />
                    <path
                        fill="#666"
                        d="M353.85 172.45q3.85-2.6 8.75-2.6 6.6 0 11.25 4.65.45.45.9.85l-1.9-2.3q-.35-.3-.6-.6-4.65-4.6-11.25-4.6-4.95 0-8.8 2.6-.9.55-1.85 1.45-.3.25-.7.55-4.65 4.65-4.65 11.3 0 1.9.35 3.55.7 3 2.45 5.55l1.6 2q-1.75-2.5-2.35-5.5-.45-1.65-.45-3.6 0-5.9 3.75-10.2.45-.55.95-1.05 1.15-1.2 2.55-2.05z"
                    />
                </g>
                <g id="PlaInd035__Layer2_0_MEMBER_6_MEMBER_0_FILL">
                    <path d="M357.7 177.65q-.95.7-1.95 1.5-3.2 3.4-3.2 8.15 0 1.35.15 2.6.55 2.1 1.8 3.95.4.6.9 1.15.25.25.35.5 1.5 1.4 3.15 2.2.5.25 1 .4 1.85.7 4.1.7 4.65 0 7.8-3.1.25-.1.35-.2 3.4-3.35 3.4-8.2v-.4q0-.85-.1-1.7-.45-2.4-1.9-4.4l-.1-.05q-.3-.5-.7-.95l-.2-.25-.05-.05q-.2-.15-.35-.35-3.35-3.35-8.15-3.35-3.6 0-6.3 1.85z" />
                    <path
                        fill="#666"
                        d="M355.75 179.15q1-.8 1.95-1.5 2.7-1.85 6.3-1.85 4.8 0 8.15 3.35.15.2.35.35l.05.05.2.25q.4.45.7.95l.1.05q1.45 2 1.9 4.4l.05-.05q-.4-3.15-2.85-5.95l-1.15-1.4q-.25-.25-.4-.5-3.5-3.4-8.4-3.4-3.7 0-6.5 2-1 .6-1.9 1.4-3.45 3.5-3.45 8.4 0 1.4.3 2.7.4 2.15 1.75 4.1l1.2 1.5q2.3 2.7 5.75 4.2l.05-.1q-.5-.15-1-.4-1.65-.8-3.15-2.2-.1-.25-.35-.5-.5-.55-.9-1.15-1.25-1.85-1.8-3.95-.15-1.25-.15-2.6 0-4.75 3.2-8.15z"
                    />
                </g>
                <g id="PlaInd035__Layer2_0_MEMBER_6_MEMBER_0_MEMBER_0_FILL">
                    <path d="M361.5 182.55q-.7.45-1.2.95-2.1 2.1-2.1 5.15 0 .9.2 1.7.15 1.15.8 2.1.15.2.25.4.25.35.5.75.2.15.35.3.95.85 1.9 1.35 1.55.75 3.3.75 2.95 0 4.95-1.9l.2-.2q2.25-2.2 2.25-5.25 0-.95-.2-1.8-.25-.95-.7-1.75-.15-.2-.25-.4-.05-.15-.15-.2l-.7-.8-.05-.1-.05-.05-.15-.05q-2.1-2.25-5.15-2.25-2.3 0-4 1.3z" />
                    <path
                        fill="#666"
                        d="M360.5 181.25q-.6.35-1.25.9-2.1 2.15-2.1 5.2 0 .85.2 1.6.2 1.05.65 1.9.05.1.15.2.05.15.1.25.15.15 1.4 1.9l.3.4q-.25-.4-.5-.75-.1-.2-.25-.4-.65-.95-.8-2.1-.2-.8-.2-1.7 0-3.05 2.1-5.15.5-.5 1.2-.95 1.7-1.3 4-1.3 3.05 0 5.15 2.25l.15.05-.85-1.15q-.1-.05-.25-.25-2.15-2.15-5.2-2.15-2.25 0-4 1.25z"
                    />
                </g>
                <g id="PlaInd035__Symbol_1_0_Layer0_0_FILL">
                    <path
                        fill="#999"
                        d="M104.45 137.95h6.05l-5.95-5.85q-.55.25-1.1.55-1.45.75-2.95 1.4l3.95 3.9z"
                    />
                    <path d="M110.5 137.95h-8.2v4.35h12.5v-4.35h-4.3m-98 4.15v-4.3H0v4.3h12.5z" />
                    <path
                        fill="#CCC"
                        d="M23.95 78.4L16.9 51.95h-6.4L17.95 80l6-1.6m91.85-38.15h-6.45l-6.95 25.9h.05l-8.9 32.9 6 1.65 16.25-60.45z"
                    />
                </g>
                <g id="PlaInd035__Symbol_1_0_Layer0_7_FILL">
                    <path d="M113.1 87l3.65 1.05 5.1-18.25-3.85-1.05L113.1 87z" />
                    <path
                        fill="#666"
                        d="M116.75 88.05L113.1 87l-1.55 5.95 14.95 3.95 3.05-11.45q.5-1.9 1.05-3.8l1.4-5.4 9.8-2.85 5.3-19.75-4.15-1.1-4.65 17.25-1 .25.05-.05-8 1.75-1.9 7.1v-.05l-1.3 4.8.05-.05-1.8 6.45-2.65-.65 4.9-18.25-4.8-1.3-5.1 18.25z"
                    />
                </g>
            </defs>
            <use xlinkHref="#PlaInd035__Layer11_0_FILL" />
            <use
                xlinkHref="#PlaInd035__Symbol_87_0_Layer0_0_FILL"
                transform="translate(0 157)"
                id="PlaInd035__col1n"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_77_0_Layer0_0_FILL"
                transform="translate(0 157)"
                id="PlaInd035__col1l"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_76_0_Layer0_0_FILL"
                id="PlaInd035__col1d"
            />
            <use xlinkHref="#PlaInd035__Layer7_0_FILL" />
            <use xlinkHref="#PlaInd035__Layer7_0_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd035__Layer7_0_MEMBER_1_FILL" />
            <use xlinkHref="#PlaInd035__Layer7_1_FILL" />
            <use
                xlinkHref="#PlaInd035__Symbol_78_0_Layer0_0_FILL"
                transform="translate(0 297.2)"
                id="PlaInd035__col2n"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_79_0_Layer0_0_FILL"
                transform="translate(0 372.8)"
                id="PlaInd035__col2d"
            />
            <use xlinkHref="#PlaInd035__Layer2_0_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_0_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_0_MEMBER_1_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_0_MEMBER_2_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_0_MEMBER_3_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_0_MEMBER_4_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_0_MEMBER_5_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_0_MEMBER_6_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_0_MEMBER_6_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_0_MEMBER_6_MEMBER_0_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_1_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_1_MEMBER_1_FILL" />
            <use xlinkHref="#PlaInd035__Layer2_1_MEMBER_2_FILL" />
            <use
                xlinkHref="#PlaInd035__Symbol_1_0_Layer0_0_FILL"
                transform="matrix(.91766 0 0 .91766 5.15 56.95)"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_1_0_Layer0_1_FILL"
                transform="matrix(.91766 0 0 .91766 .057 8.727)"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_1_0_Layer0_2_FILL"
                transform="matrix(.91766 0 0 .91766 .057 8.727)"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_1_0_Layer0_3_FILL"
                transform="matrix(.91766 0 0 .91766 .057 8.727)"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_1_0_Layer0_4_FILL"
                transform="matrix(.91766 0 0 .91766 .057 8.727)"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_1_0_Layer0_4_MEMBER_0_FILL"
                transform="matrix(.91766 0 0 .91766 .057 8.727)"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_1_0_Layer0_5_FILL"
                transform="matrix(.91766 0 0 .91766 .057 8.727)"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_1_0_Layer0_6_FILL"
                transform="matrix(.91766 0 0 .91766 .057 8.727)"
            />
            <use
                xlinkHref="#PlaInd035__Symbol_1_0_Layer0_7_FILL"
                transform="matrix(.91766 0 0 .91766 .057 8.727)"
            />
            <g>
                <use
                    xlinkHref="#PlaInd035__Symbol_1_0_Layer0_0_FILL"
                    transform="matrix(.94617 0 0 .94617 34.55 107.55)"
                />
                <use
                    xlinkHref="#PlaInd035__Symbol_1_0_Layer0_1_FILL"
                    transform="matrix(.94617 0 0 .94617 29.299 57.829)"
                />
                <use
                    xlinkHref="#PlaInd035__Symbol_1_0_Layer0_2_FILL"
                    transform="matrix(.94617 0 0 .94617 29.299 57.829)"
                />
                <use
                    xlinkHref="#PlaInd035__Symbol_1_0_Layer0_3_FILL"
                    transform="matrix(.94617 0 0 .94617 29.299 57.829)"
                />
                <use
                    xlinkHref="#PlaInd035__Symbol_1_0_Layer0_4_FILL"
                    transform="matrix(.94617 0 0 .94617 29.299 57.829)"
                />
                <use
                    xlinkHref="#PlaInd035__Symbol_1_0_Layer0_4_MEMBER_0_FILL"
                    transform="matrix(.94617 0 0 .94617 29.299 57.829)"
                />
                <use
                    xlinkHref="#PlaInd035__Symbol_1_0_Layer0_5_FILL"
                    transform="matrix(.94617 0 0 .94617 29.299 57.829)"
                />
                <use
                    xlinkHref="#PlaInd035__Symbol_1_0_Layer0_6_FILL"
                    transform="matrix(.94617 0 0 .94617 29.299 57.829)"
                />
                <use
                    xlinkHref="#PlaInd035__Symbol_1_0_Layer0_7_FILL"
                    transform="matrix(.94617 0 0 .94617 29.299 57.829)"
                />
            </g>
        </g></g>
    )
}
export default PlaInd035
